(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-clips"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // the "Hear the sounds in short clips" link under the walkthrough: Horizon's router treats a plain #hash link as
    // a page load, so scroll here instead (works whether the window or .page-wrapper is the scroller)
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a.ap-walk__clips');
      const section = a && document.getElementById('ap-clips');
      if (!section) return;
      e.preventDefault();
      // phones: land on the row itself (heading just above it), so the whole clip is on screen at once
      const target = window.matchMedia('(max-width: 749px)').matches ? section.querySelector('.ap-clips__row') : section;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);
    // arriving from a mail/ad link ending in #ap-clips (phones lost the jump when the page finished loading, 2026-10-30):
    // scroll to the clips once now and once more after the pictures above have loaded, unless the visitor scrolled already
    if (location.hash === '#ap-clips') {
      const section = document.getElementById('ap-clips');
      const jump = () => {
        const target = window.matchMedia('(max-width: 749px)').matches ? section.querySelector('.ap-clips__row') : section;
        target.scrollIntoView({ block: 'start' });
      };
      let touched = false;
      window.addEventListener('wheel', () => { touched = true; }, { once: true, passive: true });
      window.addEventListener('touchstart', () => { touched = true; }, { once: true, passive: true });
      if (section) {
        jump();
        window.addEventListener('load', () => { if (!touched) setTimeout(jump, 300); });
      }
    }
    document.querySelectorAll('[data-ap-clips]').forEach((root) => {
      const clips = [...root.querySelectorAll('.ap-clip')];
      root.querySelector('.ap-clips__row').addEventListener('scroll', () => root.classList.add('is-swiped'), { once: true });
      const stop = (li) => {
        const v = li.querySelector('video');
        v.pause();
        li.classList.remove('is-playing', 'is-loading');
      };
      const warm = (li) => {  // the neighbours start downloading now, so the next swipe plays without a wait
        const i = clips.indexOf(li);
        [clips[i - 1], clips[i + 1], clips[i + 2]].forEach((o) => {
          if (!o) return;
          const v = o.querySelector('video');
          if (!v.src) { v.preload = 'auto'; v.src = v.dataset.src; v.load(); }
        });
      };
      const play = (li) => {
        const v = li.querySelector('video');
        clips.forEach((o) => o !== li && stop(o));
        if (!v.src) v.src = v.dataset.src;
        v.muted = false;
        li.classList.add('is-loading');        // play button fades; a tap now does nothing (it used to pause)
        warm(li);
        return v.play().catch(() => li.classList.remove('is-loading'));
      };
      let started = false; // the owner tapped one: from then on the swiped-to clip starts by itself
      // iPhones only let a video play with sound after a tap ON THAT video. So on every tap we "unlock" the
      // neighbours inside the same tap: a silent play+pause each, which Safari then counts as touched.
      const primed = new WeakSet();
      const prime = (li) => {
        clips.slice(Math.max(0, clips.indexOf(li) - 2), clips.indexOf(li) + 4).forEach((o) => {
          const v = o.querySelector('video');
          if (o === li || primed.has(v) || o.classList.contains('is-playing') || o.classList.contains('is-loading')) return;
          primed.add(v);
          if (!v.src) v.src = v.dataset.src;
          v.muted = true;
          const p = v.play();
          // the silent unlock may finish AFTER a fast swipe already landed on this clip: then leave it playing
          if (p) p.then(() => { if (!o.classList.contains('is-playing') && !o.classList.contains('is-loading')) { v.pause(); v.currentTime = 0; } v.muted = false; })
                  .catch(() => { v.muted = false; });
        });
      };
      clips.forEach((li) => {
        const v = li.querySelector('video');
        li.querySelector('.ap-clip__frame').addEventListener('click', () => {
          if (li.classList.contains('is-loading')) return;   // already starting – don't turn it into a pause
          if (li.classList.contains('is-playing')) return stop(li);
          started = true;
          play(li);
        });
        v.addEventListener('playing', () => { if (li.classList.contains('is-loading')) { li.classList.remove('is-loading'); li.classList.add('is-playing'); } });
        v.addEventListener('ended', () => stop(li));
      });
      // swipe = when the row has come to rest, everything except the clip in the middle pauses. Nothing starts by
      // itself: swipe-to-play was tried 2026-10-30 and Safari on iPhone made it unreliable, so clips start on a tap only.
      const row = root.querySelector('.ap-clips__row');
      const step = () => (clips[0] ? clips[0].getBoundingClientRect().width + 16 : 300) * 2;
      root.querySelector('[data-ap-clips-prev]').addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
      root.querySelector('[data-ap-clips-next]').addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));
      let settle;
      const settled = () => {
          if (!started) return;
          const mid = row.getBoundingClientRect().left + row.clientWidth / 2;
          let best = null, dist = Infinity;
          clips.forEach((li) => {
            const r = li.getBoundingClientRect();
            const d = Math.abs(r.left + r.width / 2 - mid);
            if (d < dist) { dist = d; best = li; }
          });
          clips.forEach((o) => o !== best && stop(o));   // the clip you swiped away from goes quiet; the new one waits for a tap
      };
      row.addEventListener('scroll', () => { clearTimeout(settle); settle = setTimeout(settled, 120); }, { passive: true });
      row.addEventListener('scrollend', () => { clearTimeout(settle); settled(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-plugin-ab"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.apReady) return;
      root.dataset.apReady = '1';
      const on = new Audio();
      const off = new Audio();
      on.preload = off.preload = 'none';
      let row = null;
      let side = 'on';

      const apply = () => {
        on.muted = side !== 'on';
        off.muted = side !== 'off';
      };
      const setPlaying = (playing) => {
        if (!row) return;
        row.classList.toggle('is-playing', playing);
        row.querySelector('.ap-ab__play').setAttribute('aria-pressed', String(playing));
      };
      const playBoth = async () => {
        off.currentTime = on.currentTime;
        try {
          await Promise.all([on.play(), off.play()]);
        } catch (e) {}
      };

      root.addEventListener('click', (e) => {
        const r = e.target.closest('.ap-ab__row');
        if (!r) return;
        const ab = e.target.closest('[data-ab]');
        if (ab) {
          r.querySelectorAll('[data-ab]').forEach((b) => {
            const isOn = b === ab;
            b.classList.toggle('is-on', isOn);
            b.setAttribute('aria-checked', String(isOn));
          });
          if (r === row) {
            side = ab.dataset.ab;
            apply();
          }
          return;
        }
        if (!e.target.closest('.ap-ab__play')) return;
        if (r === row) {
          if (on.paused) playBoth();
          else {
            on.pause();
            off.pause();
          }
          return;
        }
        document.dispatchEvent(new CustomEvent('ap:play', { detail: root }));
        if (row) row.classList.remove('is-active', 'is-playing');
        row = r;
        row.classList.add('is-active');
        side = row.querySelector('[data-ab].is-on').dataset.ab;
        on.src = row.dataset.on;
        off.src = row.dataset.off;
        apply();
        playBoth();
      });

      on.addEventListener('play', () => setPlaying(true));
      on.addEventListener('pause', () => setPlaying(false));
      on.addEventListener('ended', () => {
        off.pause();
        setPlaying(false);
      });
      on.addEventListener('timeupdate', () => {
        if (!row || !on.duration) return;
        row.querySelector('.ap-ab__bar span').style.width = `${(on.currentTime / on.duration) * 100}%`;
        // keep the two files locked together
        if (Math.abs(off.currentTime - on.currentTime) > 0.05) off.currentTime = on.currentTime;
      });
      document.addEventListener('ap:play', (e) => {
        if (e.detail !== root && !on.paused) {
          on.pause();
          off.pause();
        }
      });
    };
    const boot = () => document.querySelectorAll('[data-ap-ab]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-sound-demos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fmt = (s) => (isFinite(s) ? `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}` : '');

    const init = (root) => {
      if (root.dataset.apReady) return;
      root.dataset.apReady = '1';
      const audio = root.querySelector('[data-ap-audio]');
      let current = null;

      const setRow = (row, playing) => {
        row.classList.toggle('is-playing', playing);
        row.querySelector('.ap-demo__play').setAttribute('aria-pressed', String(playing));
      };

      root.addEventListener('click', (e) => {
        const btn = e.target.closest('.ap-demo__play');
        const bar = e.target.closest('.ap-demo__bar');
        if (bar && audio.duration) {
          const r = bar.getBoundingClientRect();
          audio.currentTime = ((e.clientX - r.left) / r.width) * audio.duration;
          return;
        }
        if (!btn) return;
        const row = btn.closest('.ap-demo');
        if (current === row) {
          audio.paused ? audio.play() : audio.pause();
          return;
        }
        // Only one demo on the whole page plays at a time.
        document.dispatchEvent(new CustomEvent('ap:play', { detail: root }));
        if (current) current.classList.remove('is-active', 'is-playing');
        current = row;
        row.classList.add('is-active');
        audio.src = row.dataset.src;
        audio.play();
      });

      document.addEventListener('ap:play', (e) => {
        if (e.detail !== root && !audio.paused) audio.pause();
      });
      audio.addEventListener('play', () => current && setRow(current, true));
      audio.addEventListener('pause', () => current && setRow(current, false));
      audio.addEventListener('timeupdate', () => {
        if (!current || !audio.duration) return;
        current.querySelector('.ap-demo__fill').style.width = `${(audio.currentTime / audio.duration) * 100}%`;
        current.querySelector('.ap-demo__time').textContent = fmt(audio.duration - audio.currentTime);
      });
      audio.addEventListener('ended', () => {
        // Play the next demo, like an album.
        const next = current && current.nextElementSibling;
        if (next && next.dataset.src) next.querySelector('.ap-demo__play').click();
      });
    };

    const boot = () => document.querySelectorAll('[data-ap-demos]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
